<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kTx2Ju/media/FC-9781645365747.jpg?1685327423994" alt="This image is the cover for the book The Time Stone"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Time Stone
      </h1>
      <p class="bookDescription body article font2">
        <p>A group of unlikely heroes from the opposite sides of the track embark on the ultimate human adventure surrounding an ancient alien transportation device. As the four improbable companions travel through time in search for answers and a way home, they end up stumbling on an age-old mystery that might stop a disaster in the future from occurring. Can these four heroes step up to save the future and, maybe, learn something about themselves in the process?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey Estrella
      </h2>
      
      <p class="authorDescription body article">Jeffrey Estrella is a lawyer and writer who resides in Brooklyn, New York, with his wife. This book represents over 30 years of effort.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25901333